import React, { FC } from "react";
import {
  StyledCategoryName,
  StyledExternalLink,
  StyledNavigationLinks,
  StyledInternalLink,
  StyledNavigationList,
} from "./index.styled";

export interface FooterLink {
  isInternal?: boolean;
  isOpenNewTab?: boolean;
  name: string;
  url: string;
}

export interface FooterNavigationLinkProps {
  categoryName?: string;
  links?: FooterLink[];
  onClickHandler?: React.MouseEventHandler;
}

export const NavigationLinks: FC<FooterNavigationLinkProps> = ({
  categoryName,
  links,
  onClickHandler,
}) => {
  return (
    <StyledNavigationLinks>
      <StyledCategoryName>{!!categoryName && categoryName}</StyledCategoryName>
      <StyledNavigationList>
        {!!links &&
          links.map(({ name, url, isOpenNewTab, isInternal }, index) =>
            isInternal ? (
              <StyledInternalLink href={url} key={index}>
                {name}
              </StyledInternalLink>
            ) : (
              <StyledExternalLink
                key={index}
                href={url}
                openInSameTab={!isOpenNewTab}
                onClick={onClickHandler}
              >
                {name}
              </StyledExternalLink>
            )
          )}
        {/* empty div is intentional. ccm script inserts here based on id. */}
        <div id="teconsent" />
      </StyledNavigationList>
    </StyledNavigationLinks>
  );
};
